import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { benefits } from '../mock/mock';

const Benefits = () => {
  const { t, lang } = useApp();
  const list = benefits[lang] || benefits.en;
  const [open, setOpen] = useState(0);
  return (
    <section className="py-20 bg-[color:var(--brand-muted)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-12 items-start">
        <div className="lg:sticky lg:top-28">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-[color:var(--brand-dark)]">{t('benefits.title')}</h2>
          <p className="mt-4 text-gray-500 leading-relaxed">{t('benefits.subtitle')}</p>
          <img src="https://images.unsplash.com/photo-1599912027667-755b68b4dd3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" alt="Comfortable ride" className="mt-8 rounded-2xl w-full h-72 object-cover shadow-lg" />
        </div>
        <div className="space-y-3">
          {list.map((b, i) => (
            <div key={i} className="bg-white rounded-xl overflow-hidden border border-gray-100">
              <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between p-5 text-left">
                <span className="font-bold text-[color:var(--brand-dark)]">{b.t}</span>
                <span className="w-8 h-8 rounded-full flex items-center justify-center shrink-0" style={{ backgroundColor: open === i ? 'var(--brand-dark)' : 'var(--brand-muted)' }}>
                  {open === i ? <Minus className="w-4 h-4" style={{ color: 'var(--brand-accent)' }} /> : <Plus className="w-4 h-4 text-[color:var(--brand-dark)]" />}
                </span>
              </button>
              <div className={`px-5 overflow-hidden transition-all duration-300 ${open === i ? 'max-h-40 pb-5' : 'max-h-0'}`}>
                <p className="text-sm text-gray-500 leading-relaxed">{b.d}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
